import React from 'react';
import Hero from '../components/Hero';
import Ticker from '../components/Ticker';
import TrackChooser from '../components/TrackChooser';
import TutorsSection from '../components/TutorsSection';
import ResourceTeaser from '../components/ResourceTeaser';
import Record from '../components/Record';
import LogoWall from '../components/LogoWall';
import Contact from '../components/Contact';
import usePageMeta from '../hooks/usePageMeta';

const HomePage: React.FC = () => {
  usePageMeta({
    title: 'Finance & Consulting Interview Prep | Bulge Bracket',
    description:
      '1-on-1 interview prep for sales & trading, investment banking and consulting, coached over Zoom by professionals inside top global firms. From $65.',
    path: '/'
  });

  return (
    <>
      <Hero />
      <Ticker />
      <TrackChooser />
      <TutorsSection />
      <ResourceTeaser />
      <Record />
      <LogoWall />
      <Contact />
    </>
  );
};

export default HomePage;
